




import { defineComponent } from '@vue/composition-api';
import { loadAsyncWithLoadingState } from '@src/app/utils/loadAsyncComponent';

export default defineComponent({
    setup() {
        return {
            formComponent: loadAsyncWithLoadingState(() => import('account/countries/ro/RegisterContainer')),
        };
    },
});
